import resources from 'src/translations';
import { currentCulture } from 'src/utils/cultureUtil';
import { isDevelopmentMode } from 'src/utils/tenantUtil';
import { localizationUtil } from './utils/localizationUtil';

localizationUtil.initialize(resources, currentCulture, isDevelopmentMode());
